import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  Media: {
    height: '100%',
    width: '100%',
  },

  li: {
    lineHeight: '2rem',
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    color: 'black',
  },

  mainWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 3.125rem)',
  },

  leftWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    width: '100%',
  },

  paperWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '2rem',
    width: '100%',
    height: '100%',
  },

  insideH1: {
    marginBottom: 15,
    fontWeight: '300',
    fontSize: '1.625rem',
    lineHeight: '2rem',
  },

  insideH4: {
    marginTop: 0,
    marginBottom: 20,
    fontWeight: '300',
    fontSize: '1rem',
    lineHeight: '1.5rem',
    letterSpacing: '0.1rem',
  },

  insideBody: {
    marginTop: '1.5rem',
    fontWeight: 'normal',
    fontSize: '1rem',
    lineHeight: '1.5rem',
  },

  logoImage: {
    width: '100%',
    height: '3.125rem',
    objectPosition: 'cover',
    marginLeft: 0,
    marginRight: 'auto',
  },

  formBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '0.5rem',
    width: '30rem',
  },

  accountOptions: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  formTitle: {
    marginTop: '1.25rem',
    marginBottom: '1.25rem',
    lineHeight: '1.5rem',
    fontSize: '1rem',
    width: '100%',
    fontWeight: '400',
  },

  linearProgress: {
    marginTop: '0.5rem',
  },

  alert: {
    width: '100%',
    marginTop: 10,
    marginBottom: '0.75rem',
    padding: '0.1rem 1rem',
  },

  footer: {
    marginTop: 'auto',
    backgroundColor: '#E7EAED',
    padding: '0.625rem 0.625rem 1rem 0.625rem',
  },

  signupLink: {
    paddingTop: '0.5rem',
    textAlign: 'center',
  },

  forgotPasswordLink: {
    paddingTop: '1rem',
    textAlign: 'center',
  },

  acceptArea: {
    marginTop: '0.5rem',
    marginBottom: '0.5rem',
    color: 'black !important',
  },

  passwordDirections: {
    fontSize: '0.75rem',
    color: '#707974',
    paddingLeft: '0.25rem',
  },
}))

export { useStyles }
